import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { acceptOpportunityIncentive } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'
import { useAuthStore } from '@/stores/auth'

interface AcceptIncentiveParams {
  period: string
}

export function useAcceptIncentive() {
  const queryClient = useQueryClient()
  const user = useAuthStore((state) => state.user)
  const memberId = user?.memberId

  return useMutation({
    mutationFn: async ({ period }: AcceptIncentiveParams) => {
      if (!memberId) {
        throw new Error('Member ID not found')
      }
      return acceptOpportunityIncentive(memberId, period)
    },
    onSuccess: () => {
      toast.success('インセンティブを確認しました')
      // 確認履歴を再取得
      queryClient.invalidateQueries({
        queryKey: queryKeys.opportunity.incentiveAccepts(memberId),
      })
    },
    onError: () => {
      toast.error('インセンティブの確認に失敗しました')
    },
  })
}
